export default "__VITE_ASSET__e2c62287__"